interface PendingConfirm {
  readonly message: string;
  readonly confirmLabel: string;
  readonly resolve: (confirmed: boolean) => void;
}

/** Questions the editor asks the user; `ConfirmDialog` shows them, never the browser. */
export class Prompts {
  pending = $state.raw<PendingConfirm | null>(null);

  confirm = (message: string, confirmLabel = 'OK'): Promise<boolean> => {
    this.pending?.resolve(false);
    return new Promise((resolve) => {
      this.pending = { message, confirmLabel, resolve };
    });
  };

  answer(confirmed: boolean): void {
    const pending = this.pending;
    this.pending = null;
    pending?.resolve(confirmed);
  }
}
